import { IReviewItem } from '../../types'
import { useState } from 'react'

interface IReviewBySchoolItemProps {
  item: IReviewItem
}

const ReviewBySchoolItem = ({ item }: IReviewBySchoolItemProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const maxChar = item.content.length > 190

  return (
    <li
      key={item.id}
      className="my-5 flex w-full flex-col gap-y-4 border-b border-gray-300 pb-5 last:border-b-0 md:flex-row md:gap-y-0">
      <div className="w-45 shrink-0">
        <div className="text-sm md:text-base">{item.isAnonymous ? '익명' : `${item.author}님`}</div>
        <div className="text-sm text-trueGray-500 md:text-base">{item.schoolName}</div>
      </div>
      <div className="flex flex-col items-start gap-y-1 md:ml-10">
        <div className="font-bold text-yellow-450 md:text-base">{item.description}</div>
        <div className="whitespace-pre-line break-keep text-sm md:text-base">
          {maxChar && !isOpen ? `${item.content.substring(0, 190)}...` : item.content}
        </div>
        {maxChar && (
          <button
            className="mt-1 text-sm underline md:text-base"
            onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '간략히 보기' : '더 보기'}
          </button>
        )}
      </div>
    </li>
  )
}
export default ReviewBySchoolItem
